import React from 'react';
import {constants} from '@neosvoc/nv-platform-core-common';
import UserRoleText from './UserRoleText';

const RoleCheckbox = ({id, onChange, role, value}) => (
    <div className="form-check form-check-inline custom-control custom-checkbox">
        <input className="custom-control-input" type="checkbox" id={`${id}-${role}`}
            value={role} checked={value.includes(role)} onChange={onChange} />
        <label className="custom-control-label" htmlFor={`${id}-${role}`}>
            <UserRoleText role={role} />
        </label>
    </div>
);

// eslint-disable-next-line react/no-multi-comp
class RolesField extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(e) {
        const value = e.target.value;
        const checked = e.target.checked;
        const roles = this.props.field.value;
        if (checked) {
            this.props.form.setFieldValue(this.props.field.name, roles.concat(value));
        } else {
            this.props.form.setFieldValue(this.props.field.name, roles.filter((r) => r !== value));
        }
    }

    render() {
        const {field, id} = this.props;
        return (
            <>
                <RoleCheckbox role={constants.USER_ROLES.GUEST} value={field.value} id={id} onChange={this.handleChange} />
                <RoleCheckbox role={constants.USER_ROLES.READER} value={field.value} id={id} onChange={this.handleChange} />
                <RoleCheckbox role={constants.USER_ROLES.ORGANIZATION_ADMIN} value={field.value} id={id} onChange={this.handleChange} />
                <RoleCheckbox role={constants.USER_ROLES.ADMIN} value={field.value} id={id} onChange={this.handleChange} />
            </>
        );
    }
}

export default RolesField;
